import { makeStyles } from 'tss-react/mui';

const useStylesFloatingContainer: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  floatingContainer: {
    position: 'fixed',
    opacity: 0.8,
    maxWidth: 400,
    right: 10,
    bottom: 10,
    zIndex: 1001,
  },
}));

export default useStylesFloatingContainer;
